import { useParams } from 'react-router'
import { useLocation } from 'react-router'
import MainWarehouse from './Tabs/MainWarehouse'
import WarehouseProducts from './Tabs/WarehouseProducts'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import EditCardTabs from '../../../../../../baseComponents/EditCardTabs'
import { getBasePath } from '../../../../../../utils/globals/link'
import { useBasicData } from '../../../../../../utils/hooks/useBasicData'
import { ComponentTabObject } from '../../../../../../utils/hooks/useTabLogic'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'

type SingleWarehouseProps = ComponentWithPermissions & {}

const SingleWarehouse: React.FC<SingleWarehouseProps> = ({ userPermissions }) => {
    const location = useLocation()
    const params = useParams<{ id: string, tab?: string }>()
    const { t } = useTwinTranslation()
    const { basicData, getData } = useBasicData({ params: {id: params.id, includeRelations: true}, url: '/api/app/warehouse/getWarehouseInstance', variableToCurrentPage: 'name' })
    if (!params.id) {
        return null
    }
    const tabs: ComponentTabObject = {
        'main': { component: MainWarehouse, text: t('general', 'General'), permission: 'warehouse.main',  },
        'products': { component: WarehouseProducts, text: t('products', 'Productos'), permission: 'warehouse.stock',  },
    }

    return (<EditCardTabs basePath={getBasePath(location.pathname, params.id)} basicData={basicData} tabs={tabs} tab={params.tab} userPermissions={userPermissions} getData={getData} />)
}

export default SingleWarehouse